/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React from 'react';
import { FlowBlockDivider as DividerBlockModel } from '@staffino/model';
import {
  Box,
  convertCssUnit,
  convertShorthand,
  styled,
} from '@staffino/primitive-controls';

type LineProps = {
  height: string | number | (string | number)[];
};

const Line = styled(Box)<LineProps>(({ height}) => ({
  height,
  top: '50%',
}));

type Props = {
  block: DividerBlockModel;
};
export default function DividerBlock({ block }: Props) {
  const { size, dividerType = 'line', ...rest } = block;
  return (
    <Box height={convertCssUnit(`${size}px`)} position="relative" {...rest}>
      {dividerType === 'line' && (
        <Line
          width="90%"
          maxWidth={convertCssUnit('30rem')}
          height={convertCssUnit('1px')}
          {...convertShorthand('margin', '0 auto')}
          backgroundColor="#d8e1eb"
        />
      )}
    </Box>
  );
}
